import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';

import { SDKTextboxComponent } from './sdk-textbox.component';

@NgModule({
  imports: [
    SDKTextboxComponent,
  ],
  exports: [
    SDKTextboxComponent
  ],
  providers: [
    DatePipe
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class SDKTextboxModule { }
